import { Component, input } from '@angular/core';

import {
  EmergenceDateNotAdjustedNotificationDto,
  MissingNematodeAnalysisNotificationDto,
  MissingPcnAnalysisNotificationDto,
  PlantingDateNotAdjustedNotificationDto,
} from '../../../shared/models/models';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-missing-or-incorrect-body',
    templateUrl: './missing-or-incorrect-body.component.html',
    styleUrls: ['./missing-or-incorrect-body.component.scss'],
    imports: [TranslatePipe],
})
export class MissingOrIncorrectBodyComponent {
  notification = input.required<MissingNematodeAnalysisNotificationDto |
    MissingPcnAnalysisNotificationDto |
    PlantingDateNotAdjustedNotificationDto |
    EmergenceDateNotAdjustedNotificationDto>();
}
